import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { config } from '../../../config';
import { LoanDocumentEnum } from '../../../store/loanDocumentStore/enums/LoanDocumentEnum';
import { Component as LoanDocumentUploadPage } from '../LoanDocumentUploadPage/LoanDocumentUploadPage';

export function Component(): ReactNode {
  const { t } = useTranslation();

  return (
    <LoanDocumentUploadPage
      exampleDocumentUrl={config.loanDocuments.gap.exampleDocumentUrl}
      subtitleText={t('LoanDocumentUploadGAPPage.subtitle')}
      titleText={t('LoanDocumentUploadGAPPage.title')}
      type={LoanDocumentEnum.GAP_CONTRACT}
    />
  );
}

Component.displayName = 'LoanDocumentUploadGAPPage';
